import React, { useEffect, useState } from 'react';
import http from '../services/http';
import { endPoints } from '../utils/constanst';

const useQuestion = (planId) => {
    const [questions, setQuestions] = useState([]);

    const getQuestions = async () => { 

        console.log('loading getQuestions');
        
        const data = await http(endPoints.questions(planId)).get();

        const dataWitText = data.map(item => ({...item, text: ''}));

        setQuestions(dataWitText);

    };


    return {        
        questions,
        setQuestions,
        getQuestions
    }
}

export default useQuestion;
